module.exports = __webpack_public_path__ + "img/st.6a51cfef.png";